if (!customElements.get('tabine-variant-details')) {
  customElements.define('tabine-variant-details', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const replacement = data.html.getElementById(this.id);
        if (!replacement) return;
        const panelStates = new Map(Array.from(this.querySelectorAll('details[data-tabine-panel]'), panel => [panel.dataset.tabinePanel, panel.open]));
        this.innerHTML = replacement.innerHTML;
        this.querySelectorAll('details[data-tabine-panel]').forEach(panel => {
          if (panelStates.has(panel.dataset.tabinePanel)) panel.open = panelStates.get(panel.dataset.tabinePanel);
        });
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
